import confirmEmailConf from "./confirmEmailConf";

export default class confirmEmailService {
	static confirmEmail(token) {
		return new Promise(async (resolve, reject) => {
			try {
				let endpoint =
					confirmEmailConf.endpointConfirmEmail + "?token=" + token;
				let resp = confirmEmailConf.APIConnector.get(endpoint);
				resolve(resp);
			} catch (error) {
				reject(error);
			}
		});
	}
}



// WEBPACK FOOTER //
// ./src/provider/confirmEmail/confirmEmailService.js